import { useEffect, useRef } from "react";

export function usePrevious<T>(value: T): T {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  });

  // eslint-disable-next-line react-hooks/refs
  return ref.current;
}
